var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEldersChosen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 171,
    height: 186,
    viewBox: "0 0 171 186",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-4{fill:none}.cls-2{fill:#a2a5a6}.cls-3{fill:#0a5369}.cls-4{stroke:#4b4b4b;stroke-miterlimit:10;stroke-width:2.835px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Elders",
    transform: "translate(-1024 -614)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_813",
    fill: "none",
    d: "M0 0H171V186H0z",
    transform: "translate(1024 614)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_492",
    transform: "translate(575.507 539.31)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2389",
    d: "M646.207 125.8c-11.95-29.561-30.13-1.735-30.13-1.735s-.689-14.618 4.342-14.618c0 0 2.516-1.887 9.435-6.919 0 0 7.548-3.774 10.692 5.032 0 0 8.177 3.774 6.919 8.177 0 0 3.145 7.548-.629 9.434",
    className: "cls-2",
    transform: "translate(-59.199 -.012)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2390",
    d: "M520.608 124.3s4.742-14.466 16.259-13.208 13.549 15.1 13.549 15.1c-16.259-18.869-29.808-.629-29.808-.629",
    className: "cls-2",
    transform: "translate(-23.789 -3.46)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2391",
    d: "M474.319 302.71L474 245.121v-.038c.02-.792.027-7.807-5.97-8.268a5.626 5.626 0 0 0-4.7 1.49c-2.584 2.615-2.7 8.19-2.532 10.118l-4.083.374c-.033-.359-.761-8.846 3.687-13.362a9.593 9.593 0 0 1 7.946-2.708c7.988.615 9.872 8.387 9.755 12.448l.314 57.513z",
    className: "cls-3",
    transform: "translate(-.059 -48.604)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_491",
    transform: "translate(456.493 101.69)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2392",
    d: "M563.223 170.086a11.017 11.017 0 0 0-1.432 2.313c-3.709 11.672-7.358 23.364-11.033 35.047-.315 1-.454 2.233-1.128 2.9-1.243 1.224-2.713 2.691-4.29 2.987-2.115.4-3.6-1.145-4.291-3.33q-4.783-15.123-9.678-30.209c-.433-1.343-1.009-2.64-1.52-3.958l-.844.064a23.743 23.743 0 0 0-.4 3.079q-.064 43.239-.1 86.477a20.276 20.276 0 0 1-.44 5.289c-.933 3.39-3.789 5.039-7.246 4.538-3.069-.444-5.375-3.1-5.457-6.718-.142-6.287-.111-12.577-.128-18.866-.02-7.338-.106-14.676.029-22.011.053-2.844-1.131-3.567-3.756-3.561-2.557.006-3.463.82-3.446 3.451.087 13.522.038 27.045-.027 40.566-.018 3.751-2.22 6.54-5.379 7.155a6.685 6.685 0 0 1-7.769-3.882 12.894 12.894 0 0 1-.654-4.611q-.059-43.709-.047-87.419c0-1.075-.183-2.149-.281-3.224l-.822-.224a10.107 10.107 0 0 0-1.384 2.11c-3.323 9.706-6.591 19.431-9.875 29.149-.234.692-.28 1.726-.762 2.01-3.385 1.991-2.356 5.082-2.344 8.056.074 18.134.04 36.269.04 54.4 0 .524.181 1.219-.082 1.538-.7.848-1.6 2.123-2.408 2.118a3.178 3.178 0 0 1-2.231-2.189c-.282-2.907-.115-5.859-.117-8.794-.013-15.723.012-31.446-.062-47.169-.025-5.122-3.614-8.02-8.153-6.829-2.934.77-4.413 3.266-4.5 7.726-.034 1.753.074 3.659-2.5 3.182a2.959 2.959 0 0 1-1.974-1.809c-1.635-8.248 5.095-15.2 13.318-13.576 3.054.605 4.137-.419 4.848-3.125q4.313-16.4 8.844-32.745c2.775-10.089 3.4-10.518 14.044-10.487 10.062.028 20.124.041 30.187.089 4.9.023 6.317.906 7.878 5.562 2.76 8.236 5.322 16.538 8 24.8a8.314 8.314 0 0 0 2.276 3.645c1.518-4.7 3.05-9.394 4.549-14.1 1.78-5.586 3.616-11.156 5.256-16.783a4.7 4.7 0 0 1 4.747-3.807c8.066-.113 16.136-.157 24.2-.028 3.412.055 4.729 2.678 5.538 5.563q2.759 9.825 5.5 19.656 3.383 12.1 6.769 24.2c1.063 3.8.191 5.861-2.752 6.434-2.513.489-4.4-.3-5.127-2.89q-4.876-17.385-9.675-34.792c-.447-1.613-.723-3.288-1.323-4.84-.27-.7-1.145-1.164-1.745-1.735a6.332 6.332 0 0 0-.427 2.437c2.278 8.818 4.662 17.609 7 26.412q4.75 17.908 9.455 35.828c.864 3.313.564 3.608-2.862 3.739a20.73 20.73 0 0 1-2.2.038c-2.447-.167-3.345.99-3.324 3.38.063 7.337 0 14.675-.009 22.012 0 1.154.045 2.307.01 3.459-.15 4.881-2.656 7.648-6.878 7.626-4.025-.021-6.826-3.044-6.912-7.745-.115-6.182-.073-12.368-.086-18.552 0-2.2-.061-4.408.067-6.6.155-2.662-.843-3.722-3.633-3.711-2.7.011-3.7.8-3.653 3.607.145 8.593.178 17.193-.056 25.783a8.1 8.1 0 0 1-2.248 5.5c-1.433 1.193-4.242 1.943-5.888 1.343a7.87 7.87 0 0 1-4.229-4.779c-.747-2.855-.326-6.023-.351-9.058-.051-6.184-.145-12.369-.064-18.552.035-2.637-.854-3.776-3.623-3.8-5.034-.048-5.283-.407-4.015-5.256q7.831-29.928 15.747-59.835a27.611 27.611 0 0 0 .463-3.213z",
    className: "cls-4",
    transform: "translate(-456.493 -122.882)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2393",
    d: "M631.951 135.352a12.816 12.816 0 0 1-9.859-4.034c-2.133-2.232-4.505-4.529-5.7-7.266-.859-1.967-.115-4.729.226-7.091.23-1.592 1.167-3.072 1.494-4.663.541-2.634 2.389-3.684 4.624-4.593a6.6 6.6 0 0 0 3.013-2.223c2.02-3.154 4.883-4.156 8.354-3.681 3.3.451 5.48 2.171 6.223 5.678.188.886 1.538 1.82 2.55 2.181 2.722.97 4.653 2.216 4.234 5.6-.128 1.033.613 2.166.927 3.262.834 2.908.914 5.573-2.092 7.455a5.2 5.2 0 0 0-1.523 1.908c-2.776 4.972-6.938 7.485-12.471 7.467z",
    className: "cls-4",
    transform: "translate(-515.673 -101.69)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2394",
    d: "M535.748 138.878a13.49 13.49 0 0 1-13.693-14.057 13.793 13.793 0 0 1 14.184-13.683A14.115 14.115 0 0 1 549.9 125.15a13.8 13.8 0 0 1-14.152 13.728z",
    className: "cls-4",
    transform: "translate(-480.817 -105.195)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2395",
    d: "M478.5 233.5s7.838 1.58 8.177 9.435",
    className: "cls-4",
    transform: "translate(-8.165 -48.906)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2396",
    d: "M617.1 128.9s17.236-26.254 29.187 3.308",
    className: "cls-4",
    transform: "translate(-59.589 -6.109)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2397",
    d: "M550.174 128.455c-15.1-18.869-27.674-.629-27.674-.629",
    className: "cls-4",
    transform: "translate(-24.491 -6.757)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_86",
    d: "M0 0L32.077 0",
    className: "cls-4",
    transform: "translate(495.493 192.142)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_87",
    d: "M0 0L51.575 0",
    className: "cls-4",
    transform: "translate(547.383 217.3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEldersChosen);
export default __webpack_public_path__ + "static/media/eldersChosen.a23d07730ef01b94047b262e21c84fb7.svg";
export { ForwardRef as ReactComponent };